exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ssfe-realname {\n  height: 100%;\n  width: 100%;\n  padding: 13px;\n}\n.ssfe-realname>section {\n  height: 100%;\n  width: 100%;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 0 20px inset rgba(202,188,107,0.3);\n}\n", ""]);
